import { useState } from "react";
import { Share, Smartphone, SquarePlus } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { usePwaInstall } from "@/hooks/usePwaInstall";

const IOS_STEPS = [
  ["Abra esta página pelo Safari.", null],
  ["Toque no botão Compartilhar.", Share],
  ["Escolha \"Adicionar à Tela de Início\".", SquarePlus],
  ["Toque em \"Adicionar\".", null],
];

export const IosInstallDialog = ({ open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-sm" data-testid="ios-install-dialog">
      <DialogHeader>
        <DialogTitle className="font-display flex items-center gap-2"><span className="w-9 h-9 rounded-xl bg-primary text-primary-foreground flex items-center justify-center"><Smartphone className="w-5 h-5" /></span>Instale o Pedrada no seu iPhone</DialogTitle>
        <DialogDescription>Para instalar o aplicativo e abrir direto da tela inicial:</DialogDescription>
      </DialogHeader>
      <ol className="space-y-2.5 text-sm">
        {IOS_STEPS.map(([t, I], i) => (
          <li key={i} className="flex items-center gap-3 rounded-xl border border-border bg-secondary/30 px-3 py-2.5" data-testid={`ios-install-step-${i + 1}`}>
            <span className="num w-6 h-6 rounded-full bg-primary/15 text-primary text-xs font-bold flex items-center justify-center shrink-0">{i + 1}</span>
            <span className="flex-1">{t}</span>
            {I && <I className="w-4 h-4 text-muted-foreground shrink-0" />}
          </li>
        ))}
      </ol>
      <p className="text-xs text-muted-foreground">No iPad o caminho é o mesmo: Safari → Compartilhar → Adicionar à Tela de Início.</p>
    </DialogContent>
  </Dialog>
);

export const InstallAppButton = ({ collapsed = false, variant = "sidebar", onDone, onIos }) => {
  const { mode, install } = usePwaInstall();
  const [ios, setIos] = useState(false);
  if (mode === "installed" || mode === "unavailable") return null;
  const label = mode === "ios" ? "Como instalar" : "Instalar App";
  const click = async () => {
    if (mode === "ios") return onIos ? onIos() : setIos(true);
    const outcome = await install();
    if (outcome === "accepted") { toast.success("Pedrada instalado! Abra pelo ícone na sua tela."); onDone?.(); }
  };
  return (
    <>
      {variant === "sidebar" ? (
        <button type="button" data-testid="nav-install-app" onClick={click} title={label} className={`w-full flex items-center gap-2 text-xs py-2 rounded-lg bg-primary/10 text-primary hover:bg-primary/20 transition-colors ${collapsed ? "justify-center px-0" : "px-3"}`}>
          <Smartphone className="w-3.5 h-3.5 shrink-0" /><span className={`whitespace-nowrap overflow-hidden transition-all duration-300 ${collapsed ? "w-0 opacity-0" : "opacity-100"}`}>{label}</span>
        </button>
      ) : (
        <Button variant="outline" className="w-full justify-start" data-testid="mobile-install-app" onClick={click}><Smartphone className="w-4 h-4 mr-2" />{label}</Button>
      )}
      <IosInstallDialog open={ios && !onIos} onOpenChange={setIos} />
    </>
  );
};
